"use strict";

/**
 * openBSE 根命名空间
 * @namespace
 */
var openBSE = require('./openBSE');

window.openBSE = openBSE;